export default __webpack_public_path__ + "static/PNS_PHOTOGRAPHY_2-210effc689bcfb25b9f48bbf99ecc128.jpg";